const panelTypes = {
    PANEL: 1,
    BREAK: 2
};

export default panelTypes;
